//#region src/reward_points_display_mode.ts
var RewardPointsDisplayMode = /* @__PURE__ */ function(RewardPointsDisplayMode) {
	RewardPointsDisplayMode["Hide"] = "hide";
	RewardPointsDisplayMode["ShowInLabel"] = "show-in-label";
	RewardPointsDisplayMode["ShowAsPill"] = "show-as-pill";
	return RewardPointsDisplayMode;
}(RewardPointsDisplayMode || {});
//#endregion
export { RewardPointsDisplayMode };

//# sourceMappingURL=reward_points_display_mode.js.map